import debounce from "lodash.debounce";
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from "react";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import { fetchGet, toQueryString } from "../../../../service/api_client";
import AutoCompleteField from "../../../../ui/new_components/common/autocomplete";
import { Project } from "../../../inventory/models/project_model";

interface ProjectSearchFieldPropsV2 {
  onSelect: (data: Project) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: Project | null;
}

const ProjectSearchFieldV2: FunctionComponent<ProjectSearchFieldPropsV2> = (
  props
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/project/`;
  const { showToast } = useToast();
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [addNew, setAddNew] = useState(false);
  const [data, setData] = useState<Project[]>();
  const getData = async (prop: {
    search?: string;
    page: number;
    count: number;
    all?: boolean;
  }) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success && Array.isArray(res.data?.data)) {
        const openProjects = res.data.data.filter(
          (project: Project) => project.projectStatus === "Open"
        );
        setData(openProjects);
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const debouncedHandler = useCallback(
    debounce((query) => {
      if (query) getData({ search: query, page: 1, count: 20, all: true });
      else setData(undefined);
    }, 500),
    []
  );

  useEffect(() => {
    if (search && edit) {
      if (props.value && props.value.name === search) return;
      debouncedHandler(search);
    }
  }, [search]);
  useEffect(() => {
    setSearch(props.value?.name ?? "");
  }, [props.value]);

  useEffect(() => {
    if (props.disabled) {
      setEdit(false);
      setSearch(props.value?.name ?? "");
    }
  }, [props.disabled]);

  return (
    <div className="flex gap-1 items-center w-full h-16">
      {edit ? (
        <AutoCompleteField
          disabled={props.disabled}
          onAddNew={() => {
            setAddNew(true);
          }}
          loading={loading}
          value={search}
          placeholder={props.placeholder ?? "Select an item "}
          onSelect={(val) => {
            setEdit(false);
            setSearch(val.value.name);
            props.onSelect(val.value);
          }}
          suggestions={data?.map((d) => ({
            label: (
              <div className="text-xs">
                <b>{d.name} </b>
              </div>
            ),

            value: d,
          }))}
          onChange={setSearch}
        />
      ) : (
        <React.Fragment>
          {props.value?.name && (
            <span
              onClick={(e) => {
                e.stopPropagation(); // Prevent edit mode
                navigator.clipboard.writeText(props.value?.name ?? "");
                showToast({
                  type: ToastType.info,
                  text: "Copied to clipboard!",
                });
              }}
              title="Copy to clipboard"
              className="text-gray-500 hover:text-gray-700 cursor-pointer"
            >
              📋
            </span>
          )}
          <div
            title={search}
            className={`text-xs py-3 h-16 rounded focus:outline-none w-full border ${
              search ? "break-words overflow-y-auto" : "text-gray-400"
            }`}
            style={{
              maxWidth: "100%",
              overflowY: "hidden",
              overflowX: "auto",
            }}
            onClick={() => {
              if (!props.disabled) {
                setEdit(true);
                // setSearch(emp?.name ?? "");
              }
            }}
          >
            <span className="flex-1 text-left break-words w-full text-xs">
              {search || props.placeholder || "Select a Project "}
            </span>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default ProjectSearchFieldV2;
